import { render, staticRenderFns } from "./redPackets.vue?vue&type=template&id=780f2758&scoped=true&"
import script from "./redPackets.vue?vue&type=script&lang=js&"
export * from "./redPackets.vue?vue&type=script&lang=js&"
import style0 from "./redPackets.vue?vue&type=style&index=0&id=780f2758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780f2758",
  null
  
)

export default component.exports